import { computed } from "vue";
import { useTheme } from "vuetify";

import { useAppCookies } from "./useCookies";
import faviconLight from "@/../public/favicon-light.ico";
import faviconDark from "@/../public/favicon-dark.ico";

export function useAppTheme() {
  const theme = useTheme();
  const { getCookies, setCookies } = useAppCookies();

  const dark = computed(() => {
    return theme.global.current.value.dark;
  });

  const toggleTheme = () => {
    const userPreferences = (getCookies("userPreferences") as Record<string, unknown>) ?? {};
    const newTheme = dark.value ? "light" : "dark";
    userPreferences.theme = newTheme;
    theme.global.name.value = newTheme;
    setCookies("userPreferences", userPreferences);
    toggleFavicon();
  };

  const toggleFavicon = () => {
    const favicon = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
    if (favicon) {
      favicon.href = theme.global.current.value.dark ? faviconDark : faviconLight;
    }
  };

  toggleFavicon();

  return { theme, dark, toggleTheme };
}
